import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { Provincia } from '../models/provincia';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/Provincias';

@Injectable({
  providedIn: 'root'
})
export class ProvinciaService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getPais(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetByPais?paisid=' + code })
  }

  save(provincia: Provincia)
  {
    return this._http.post({ url: baseUrl + '/Save', body: provincia });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });   
  }
}

